(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4943],{

/***/ 11627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prism-academy",
      function () {
        return __webpack_require__(74577);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PrismAcademy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/propTypes.js
var propTypes = __webpack_require__(19941);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/renderBlockByType.js + 25 modules
var renderBlockByType = __webpack_require__(94061);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/AlertPreviewMode/index.js + 1 modules
var AlertPreviewMode = __webpack_require__(51144);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Standard/Page.js








const Page = (param)=>{
    let { isPreview , post , pageProps  } = param;
    var ref, ref1;
    const [t] = (0,i18/* useLocale */.bU)("standard-pages");
    const { siteDomain , prefix , components  } = pageProps;
    const { metaTitle ="" , metaDescription ="" , metaCanonical , slug , thumbnail , contentReference  } = post;
    const thumbnailUrl = (thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) || "";
    const url = "".concat(siteDomain, "/").concat(prefix ? "".concat(prefix, "/") : "").concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: metaTitle,
                description: metaDescription,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: metaTitle,
                        description: metaDescription,
                        url: url,
                        image: thumbnailUrl || t("META_IMAGE"),
                        imageSecureUrl: thumbnailUrl || t("META_IMAGE_SECURE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META_TWITTER_CARD"),
                        site: t("META_TWITTER_SITE"),
                        creator: t("META_TWITTER_CREATOR"),
                        title: metaTitle,
                        description: metaDescription,
                        image: thumbnailUrl || t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: "noindex, nofollow"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: metaCanonical || url
                    })
                ]
            }),
            isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertPreviewMode/* default */.Z, {}) : null,
            contentReference.map((0,renderBlockByType/* default */.Z)(slug, components))
        ]
    });
};
Page.propTypes = {
    isPreview: prop_types.bool,
    post: (0,prop_types.shape)({
        metaTitle: prop_types.string,
        metaDescription: prop_types.string,
        metaCanonical: prop_types.string,
        slug: prop_types.string.isRequired,
        thumbnail: propTypes/* file */.t,
        contentReference: prop_types.array
    }),
    pageProps: propTypes/* pageProps */.x
};
/* harmony default export */ var Standard_Page = (Page);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/checkPreviewMode.js + 1 modules
var checkPreviewMode = __webpack_require__(17335);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/contentfulSanitizer.js
var contentfulSanitizer = __webpack_require__(50420);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Standard/index.js












const contentfulStandardFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulStandardPage = (param)=>{
        let { isPreview , post  } = param;
        const { brandCode , resources =null  } = pageProps;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            slug: post.slug,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_Page, {
                    isPreview: isPreview,
                    post: post,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulStandardPage.getInitialProps = async (param)=>{
        let { req , query  } = param;
        const { slug  } = query;
        const isPreview = (0,checkPreviewMode/* default */.Z)(req);
        const client = (0,createClient/* default */.Z)(contentfulProps, isPreview);
        const fullSlug = Array.isArray(slug) ? slug.join("/") : slug;
        const items = await client.getEntries({
            content_type: "pageStandard",
            "fields.slug": fullSlug,
            include: 2
        });
        if (items.total === 0) {
            return {
                post: null
            };
        }
        return {
            isPreview,
            post: (0,contentfulSanitizer/* sanitize */.N)(items.items[0].fields)
        };
    };
    ContentfulStandardPage.propTypes = {
        ...Standard_Page.propTypes
    };
    ContentfulStandardPage.postConditions = [
        [
            (param)=>{
                let { post  } = param;
                return post;
            },
            (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
        ]
    ];
    return (0,pipe/* default */.Z)(ContentfulStandardPage, WithConditions/* default */.ZP);
};
/* harmony default export */ var Standard = (contentfulStandardFactory);

// EXTERNAL MODULE: ./src/AppError/index.js
var AppError = __webpack_require__(57694);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Lead.js
var Lead = __webpack_require__(25672);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 4 modules
var SiteLayout = __webpack_require__(95309);
// EXTERNAL MODULE: ./src/services/index.js + 20 modules
var services = __webpack_require__(17104);
// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped.js
var SimpleSectionStripped = __webpack_require__(37045);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
;// CONCATENATED MODULE: ./src/Contentful/Template.js





const Template = (param)=>{
    let { title , subtitle , backgroundColor , anchor , children , textAlign ="center" , containerProps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
        bgColor: backgroundColor,
        containerProps: containerProps,
        children: [
            anchor && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                name: anchor,
                href: "/",
                children: " "
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                sx: {
                    textAlign
                },
                spacing: {
                    mb: 0
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                sx: {
                    textAlign
                },
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: children
            })
        ]
    });
};
Template.propTypes = {
    title: prop_types.string,
    subtitle: prop_types.string,
    backgroundColor: prop_types.string,
    anchor: prop_types.string,
    children: prop_types.node.isRequired,
    textAlign: (0,prop_types.oneOf)([
        "left",
        "center"
    ]),
    containerProps: (0,prop_types.shape)({
        sm: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types.bool
    })
};
/* harmony default export */ var Contentful_Template = (Template);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var Link = __webpack_require__(24661);
;// CONCATENATED MODULE: ./src/Contentful/LinksBlock.js






const LinksBlock = (param)=>{
    let { linkReference , stickyToc =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        fullWidthBorder: true,
        utility: {
            bgColor: "5--12"
        },
        sticky: stickyToc,
        children: linkReference.map((param)=>/*#__PURE__*/ {
            let { fields: { linkText , linkUrl  }  } = param;
            return (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: linkUrl,
                    children: linkText
                })
            }, linkUrl);
        })
    });
};
LinksBlock.propTypes = {
    stickyToc: prop_types.bool,
    linkReference: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            linkText: prop_types.string.isRequired,
            linkUrl: prop_types.string.isRequired
        })
    }))
};
/* harmony default export */ var Contentful_LinksBlock = (LinksBlock);

;// CONCATENATED MODULE: ./src/Apps/PrismAcademy/index.js
















const PrismAcademyLayout = (param)=>{
    let { children  } = param;
    const [t] = (0,i18/* useLocale */.bU)("prism-academy");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                color: "gradient",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
                        md: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/graphpad/logo/text-logo-prism-academy.svg",
                                alt: t("PRISM_ACADEMY")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                                children: t("LEAD")
                            })
                        ]
                    })
                })
            }),
            children
        ]
    });
};
PrismAcademyLayout.propTypes = {
    children: prop_types.node.isRequired
};
const PrismAcademyApp = Standard({
    Layout: PrismAcademyLayout,
    AppError: AppError/* default */.Z,
    contentfulProps: {
        environment: "master",
        space: "gyag548snr3z",
        accessToken: "G5ccCuVhJnKaI_A32Fb0iqg4-_Ob0dHapTddg34pJ-o"
    },
    pageProps: {
        brandCode: "gp",
        siteDomain: "https://www.graphpad.com",
        components: {
            sectionTemplate: Contentful_Template,
            linksBlock: Contentful_LinksBlock
        }
    }
});
/* harmony default export */ var PrismAcademy = ((0,pipe/* default */.Z)(PrismAcademyApp, withErrorHandling/* default */.Z, services/* default */.ZP));

;// CONCATENATED MODULE: ./pages/prism-academy/index.js



/***/ }),

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
;// CONCATENATED MODULE: ./src/AppError/Error404.js






const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("app-error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("404.META_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("404.TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("404.DESCRIPTION")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js






const Error500 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. Something has gone wrong with the application.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please try again later or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error500 = (Error500);

;// CONCATENATED MODULE: ./src/AppError/Error503.js




const Error503 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Service Unavailable"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable."
            })
        ]
    });
/* harmony default export */ var AppError_Error503 = (Error503);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js





const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            utility: {
                bgColor: "black"
            },
            className: "panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = ( false ? 0 : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
// EXTERNAL MODULE: ./src/sentry.js + 79 modules
var sentry = __webpack_require__(77264);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404,
    503: AppError_Error503
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    if (res) {
        res.statusCode = error.code;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.code !== 503 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 59093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87385);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95309);






/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 57694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38100);

/* harmony default export */ __webpack_exports__["Z"] = (_AppError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 71802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38100);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 25672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);




const HeroLead = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__lead", className),
        ...props
    });
};
HeroLead.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLead);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1888,7869,6445,1408,6468,768,9217,5309,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(11627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);